const ViewPatientDetails = ({ lang = "en" }) => {
  const patientData = {
    general: {
      dob: "02-09-2000",
      gender: "Male",
      condition: "Smoker",
      weight: "70 Kgs",
      bloodGroup: "B Positive",
    },
    medicines: [{ name: "Panadol", dosage: "10mg", status: "Active" }],
    allergies: [
      { name: "Chocolate Allergy", details: "Detailsdetailsdetailsdetail" },
    ],
    conditions: [{ name: "Surgery", details: "Ghsiyabbseww Whhjvjvjvjvj" }],
    procedures: [
      {
        name: "Name 1",
        type: "Throat Surgery",
        date: "2026-02-12",
        status: "Current",
      },
    ],
    mainDoctor: {
      name: "Dr. Steven",
      role: "General",
      npi: "N/A",
      specialty: "General",
    },
    otherDoctors: [
      {
        name: "Dr. Drew",
        role: "Neurology",
        npi: "N/A",
        specialty: "Neurology",
      },
      {
        name: "Dr. King",
        role: "Orthopedics",
        npi: "N/A",
        specialty: "Orthopedics",
      },
    ],
    hospitals: [
      {
        name: "Hospital 1",
        role: "Specialty",
        npi: "8181818181",
        specialty: "Hsbsbs",
      },
      {
        name: "Hospital 2",
        role: "General",
        npi: "8282828288282",
        specialty: "Bwbwbwbw",
      },
      {
        name: "Hospital 3",
        role: "General",
        npi: "828288282",
        specialty: "Nwjwnwbne",
      },
    ],
    emergencyContacts: [
      { name: "Marge", phone: "+1 (876) 788-8888", relation: "Grandma" },
      { name: "Konner", phone: "+1 (727) 281-8181", relation: "Brother" },
    ],
    insurance: [
      { name: "Primary Insurance: Medicare", id: "8272829299" },
      { name: "Secondary Insurance: Bluecross", id: "8728286" },
      { name: "Life Insurance: Janajvjw", id: "8728286" },
    ],
  };

  const Section = ({ title, children }) => (
    <div className="mb-8">
      <h2 className="text-xl font-bold text-[#2d348f] mb-4 pb-2">{title}</h2>
      {children}
    </div>
  );

  const Table = ({ headers, children }) => (
    <div className="overflow-x-auto rounded-2xl border border-gray-200">
      <table className="w-full bg-white">
        <thead>
          <tr className="bg-white border-b border-gray-200">
            {headers.map((header, idx) => (
              <th
                key={idx}
                className="px-4 py-3 text-left text-sm font-semibold text-gray-700 bg-white"
              >
                {header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>{children}</tbody>
      </table>
    </div>
  );

  const TableRow = ({ data }) => (
    <tr className="border-b border-gray-100 hover:bg-gray-50 transition-colors">
      {data.map((cell, idx) => (
        <td key={idx} className="px-4 py-3 text-sm text-gray-600">
          {cell}
        </td>
      ))}
    </tr>
  );

  return (
    <div className="max-w-6xl mx-auto p-6 md:p-8 min-h-screen">
      {/* Header */}
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-[#2d348f] mb-2">
          Patient Details
        </h1>
        <p className="text-gray-600">Complete medical information</p>
      </div>

      {/* General Information */}
      <Section title="General Information">
        <div className="overflow-x-auto rounded-2xl border border-gray-200">
          <table className="w-full bg-white">
            <thead className="bg-white">
              <tr className="bg-white border-b border-gray-200">
                <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700">
                  DOB
                </th>
                <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700">
                  Gender
                </th>
                <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700">
                  Condition
                </th>
                <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700">
                  Weight
                </th>
                <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700">
                  Blood Group
                </th>
              </tr>
            </thead>
            <tbody>
              <tr className="border-b border-gray-100 hover:bg-gray-50">
                <td className="px-4 py-3 text-sm text-gray-600">
                  {patientData.general.dob}
                </td>
                <td className="px-4 py-3 text-sm text-gray-600">
                  {patientData.general.gender}
                </td>
                <td className="px-4 py-3 text-sm text-gray-600">
                  {patientData.general.condition}
                </td>
                <td className="px-4 py-3 text-sm text-gray-600">
                  {patientData.general.weight}
                </td>
                <td className="px-4 py-3 text-sm text-gray-600">
                  {patientData.general.bloodGroup}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </Section>

      {/* Medicine */}
      <Section title="Medicine">
        <Table headers={["Name", "Dosage", "Status"]}>
          {patientData.medicines.map((med, idx) => (
            <TableRow
              key={idx}
              data={[
                med.name,
                med.dosage,
                <span key={idx} className="text-green-600 font-medium">
                  {med.status}
                </span>,
              ]}
            />
          ))}
        </Table>
      </Section>

      {/* Allergies */}
      <Section title="Allergies">
        <Table headers={["Name", "Details"]}>
          {patientData.allergies.map((allergy, idx) => (
            <TableRow key={idx} data={[allergy.name, allergy.details]} />
          ))}
        </Table>
      </Section>

      {/* Conditions */}
      <Section title="Conditions">
        <Table headers={["Name", "Details"]}>
          {patientData.conditions.map((condition, idx) => (
            <TableRow key={idx} data={[condition.name, condition.details]} />
          ))}
        </Table>
      </Section>

      {/* Procedures */}
      <Section title="Procedures">
        <Table headers={["Procedure Name", "Procedure Type", "Date", "Status"]}>
          {patientData.procedures.map((proc, idx) => (
            <TableRow
              key={idx}
              data={[
                proc.name,
                proc.type,
                proc.date,
                <span key={idx} className="text-blue-600 font-medium">
                  {proc.status}
                </span>,
              ]}
            />
          ))}
        </Table>
      </Section>

      {/* Main Doctor */}
      <Section title="Doctors (Main Doctor)">
        <div className="overflow-x-auto rounded-2xl border border-gray-200">
          <table className="w-full bg-white">
            <thead>
              <tr className="bg-white border-b border-gray-200">
                <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700">
                  Name
                </th>
                <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700">
                  Role
                </th>
                <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700">
                  NPI Number
                </th>
                <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700">
                  Specialty
                </th>
              </tr>
            </thead>
            <tbody>
              <TableRow
                data={[
                  patientData.mainDoctor.name,
                  patientData.mainDoctor.role,
                  patientData.mainDoctor.npi,
                  patientData.mainDoctor.specialty,
                ]}
              />
            </tbody>
          </table>
        </div>
      </Section>

      {/* Other Doctors */}
      <Section title="Doctors (Other Doctors)">
        <Table headers={["Name", "Role", "NPI Number", "Specialty"]}>
          {patientData.otherDoctors.map((doctor, idx) => (
            <TableRow
              key={idx}
              data={[doctor.name, doctor.role, doctor.npi, doctor.specialty]}
            />
          ))}
        </Table>
      </Section>

      {/* Hospitals */}
      <Section title="Hospitals">
        <Table headers={["Name", "Role", "NPI Number", "Specialty"]}>
          {patientData.hospitals.map((hospital, idx) => (
            <TableRow
              key={idx}
              data={[
                hospital.name,
                hospital.role,
                hospital.npi,
                hospital.specialty,
              ]}
            />
          ))}
        </Table>
      </Section>

      {/* Emergency Contacts */}
      <Section title="Emergency Contacts">
        <Table headers={["Contact Name", "Contact Phone", "Relation"]}>
          {patientData.emergencyContacts.map((contact, idx) => (
            <TableRow
              key={idx}
              data={[contact.name, contact.phone, contact.relation]}
            />
          ))}
        </Table>
      </Section>

      {/* Insurance */}
      <Section title="Insurance">
        <Table headers={["Name", "Member ID"]}>
          {patientData.insurance.map((ins, idx) => (
            <TableRow key={idx} data={[ins.name, ins.id]} />
          ))}
        </Table>
      </Section>
    </div>
  );
};

export default ViewPatientDetails;
